module.exports = __webpack_public_path__ + "img/March.9bea8307.png";